import { sel } from 'fxjs/es';

export const isMultiplyStyle = function (fcanvas_or_size_face) {
  return !!sel('preview.multiply', fcanvas_or_size_face);
};
